//Menu 
jQuery(document).ready(function($) {

   
       
       // Add close button dynamically when menu opens (only once)
if ($('#menuClose').length === 0) {
    $('.menu-wrap').append('<button id="menuClose" class="menu-close">✕</button>');
}

// Toggle menu
$('#menuToggle').click(function(e) {
    e.stopPropagation();
    e.preventDefault();
    $('.menu-wrap').toggleClass('active');
});

// Close menu when clicking the dynamically added button
$(document).on('click', '#menuClose', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $('.menu-wrap').removeClass('active');
});

  
        
        // if ($(window).width() <= 992) {
        //   $('.has-submenu').click(function(e) {
        //     e.preventDefault();
        //     $(this).toggleClass('active');
        //     $(this).next('.submenu').toggleClass('active');
        //   });
        // }
  
       
        // $(window).resize(function() {
        //   if ($(window).width() > 992) {
        //     $('#menu').removeClass('active');
        //     $('#menuToggle').removeClass('active');
        //     $('.submenu').removeClass('active');
        //     $('.has-submenu').removeClass('active');
        //   } else {
        //     // Re-bind click events for mobile
        //     $('.has-submenu').off('click').click(function(e) {
        //       e.preventDefault();
        //       $(this).toggleClass('active');
        //       $(this).next('.submenu').toggleClass('active');
        //     });
        //   }
        // });
  
        // Close menu when clicking on a non-submenu link in mobile view
        $('.menu > li > a:not(.has-submenu)').click(function() {
          if ($(window).width() <= 992) {
            $('#menu').removeClass('active');
            $('#menuToggle').removeClass('active');
          }
        });  
        
       
          $('.tab-link').click(function() {
            var tab_id = $(this).attr('data-tab');
        
            $('.tab-link').removeClass('active');
            $('.tab-content').removeClass('active');
        
            $(this).addClass('active');
            $("#" + tab_id).addClass('active');
          });
        
});

$(document).ready(function(){
  var owl = $('#featured-productSlider').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        margin: 0
      },
      576: {
        items: 2,
        stagePadding: 0
      },
      768: {
        items: 2,
        stagePadding: 0
      },
      1024: {
        items: 4,
        stagePadding: 0
      }
    }
  });

  // Custom navigation
  $('#nextBtn').click(function () {
    owl.trigger('next.owl.carousel');
  });

  $('#prevBtn').click(function () {
    owl.trigger('prev.owl.carousel');
  });
});

$(document).ready(function(){
  var owl = $('#testimonoal-slider').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        margin: 0
      },
      576: {
        items: 2,
        stagePadding: 0
      },
      768: {
        items: 2,
        stagePadding: 0
      },
      1024: {
        items: 4,
        stagePadding: 0
      }
    }
  });

  // Custom navigation
  $('#testi-nextBtn').click(function () {
    owl.trigger('next.owl.carousel');
  });

  $('#testi-prevBtn').click(function () {
    owl.trigger('prev.owl.carousel');
  });
});